import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/conference-events/new/loading';

export const Route = createFileRoute('/_private/conferences-and-events/new')({
  pendingComponent: Loading,
});
